import { SvgIcon, } from "@material-ui/core";
import React from "react";

const MagnifyIcon = (props) => {

  return (
    React.createElement(SvgIcon, { ...props,}
      , React.createElement('path', { d: "M5.91667 0.5C7.35326 0.5 8.73101 1.07068 9.74683 2.0865C10.7627 3.10233 11.3333 4.48008 11.3333 5.91667C11.3333 7.25833 10.8417 8.49167 10.0333 9.44167L10.2583 9.66667H10.9167L15.0833 13.8333L13.8333 15.0833L9.66667 10.9167V10.2583L9.44167 10.0333C8.49167 10.8417 7.25833 11.3333 5.91667 11.3333C4.48008 11.3333 3.10233 10.7627 2.0865 9.74683C1.07068 8.73101 0.5 7.35326 0.5 5.91667C0.5 4.48008 1.07068 3.10233 2.0865 2.0865C3.10233 1.07068 4.48008 0.5 5.91667 0.5ZM5.91667 2.16667C3.83333 2.16667 2.16667 3.83333 2.16667 5.91667C2.16667 8 3.83333 9.66667 5.91667 9.66667C8 9.66667 9.66667 8 9.66667 5.91667C9.66667 3.83333 8 2.16667 5.91667 2.16667Z"                                                                   ,} )
    )
  )
};

export default MagnifyIcon;